type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  linkLabel?: string;
  linkHref?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  linkLabel,
  linkHref,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 border-b border-background-200/80 pb-5 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <span className="flex items-center gap-2 text-xs tracking-[0.22em] text-primary-600">
          <span className="h-px w-6 bg-primary-400" />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold tracking-wide text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {linkLabel && linkHref && (
        <a
          href={linkHref}
          className="group flex shrink-0 items-center gap-1.5 text-sm font-medium text-foreground-800 transition-colors hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          {linkLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
          </span>
        </a>
      )}
    </div>
  );
}